import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import api from "../../services/api";

const MonthlyEarnings = () => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const [state, setState] = useState({
    series: [],
    options: {
      chart: {
        height: 350,
        type: "line",
        stacked: false,
        animations: { 

           
           
          enabled: true,
          easing: "easeinout",
          speed: 900
        }
      },

      title: {
        text: "Payments vs Refunds",
        align: "left",
        style: {
          color: "#000 !important",
          fontWeight: 700
        }
      },

      legend: {
        position: "top",
        labels: {
          colors: "#000"
        }
      },

      xaxis: {
        categories: [],
        labels: {
          style: {
            colors: "#000",
            fontSize: "13px",
            fontWeight: 700
          }
        }
      },

      yaxis: [
        {
          labels: {
            style: {
              colors: "#000",
              fontSize: "13px",
              fontWeight: 700
            }
          },
          title: {
            text: "Amount (₹)",
            style: {
              color: "#000",
              fontWeight: 700
            }
          }
        }
      ]
    }

  });

  useEffect(() => {
    fetchChartData();
  }, []);

  const fetchChartData = async () => {
    try {
      const year = new Date().getFullYear();

      const response = await api.post(
        `${backendUrl}course-payments-overall-by-year`,
        { year }
      );

      const breakdown = response.data?.data?.monthly_breakdown || {};

      const months = Object.keys(breakdown);

      const paidAmounts = months.map(m => breakdown[m].paid_amount);
      const refundAmounts = months.map(m => breakdown[m].refund_amount);
      const netAmounts = months.map(m =>
        breakdown[m].paid_amount - breakdown[m].refund_amount
      );

      setState(prev => ({
        ...prev,
        series: [
          {
            name: "Paid Amount",
            type: "column",
            data: paidAmounts
          },
          {
            name: "Refund Amount",
            type: "column",
            data: refundAmounts
          },
          {
            name: "Net Amount",
            type: "line",
            data: netAmounts
          }
        ],
        // --- THIS IS THE FIX ---
        // We spread prev.options.xaxis to keep its existing properties
        // (like the 'labels' style) and only update 'categories'.
        options: {
          ...prev.options,
          xaxis: {
            ...prev.options.xaxis, // <-- Keeps old settings
            categories: months     // <-- Overwrites only the categories
          }
        }
        // --- END OF FIX ---
      }));

    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div>
      <ReactApexChart
        options={state.options}
        series={state.series}
        type="line"
        height={350}
      />
    </div>
  );
};

export default MonthlyEarnings;